import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { take } from 'rxjs/operators';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-VII',
    templateUrl: './rs005-card-VII.component.html'
})

export class Rs005CardVIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listPresencaSementes?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listPresencaSementesOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Descarte da Mesa de Seleção', false);
        if (this.isBasica || this.isComercial) {
            this.formulario = this.formBuilder.group({
                //Umidade: [null, []],
                Peso_liquido_carga_sem_palha_kg: [null, []],
                Peso_espigas_atipicas_kg: [null, []],
                Peso_espigas_fora_padrao_kg: [null, []],
                Peso_descarte_mesa_selecao_kg: [null, []],
                Descarte_mesa_selecao: [null, []],
                Espigas_atipicas: [null, []],
                Presenca_outras_sementes: [null, Validators.required],
            });
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                created_by: [null, [Validators.required]],
                responsavel_lancamento: [null, [Validators.required]],
                observacao: [null, []],
            });
            this.step = 'Observação e Responsável'
        }

    }

    async ngOnInit(): Promise<void> {
        await this.getLists();
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    private async getLists(): Promise<void> {
        await this.getListPresencaSementes();
    }

    public async getListPresencaSementes(): Promise<void> {
        await this.formularioService.getListDropDownList('rs005', 'presenca_outras_sementes').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listPresencaSementes = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listPresencaSementesOriginal = this.listPresencaSementes;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async createFilterPresencaSementes(value: string): Promise<void> {
        if (!!value && value.length > 0) {
            if (this.listPresencaSementesOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listPresencaSementes = this.listPresencaSementesOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listPresencaSementes = this.listPresencaSementesOriginal;
            }
        } else {
            this.listPresencaSementes = this.listPresencaSementesOriginal;
        }
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }
}